import {
  PopoverProps as MantinePopoverProps,
  Popover as MantinePopover,
  PopoverTargetProps as MantinePopoverTargetProps,
  PopoverTarget as MantinePopoverTarget,
  PopoverDropdownProps as MantinePopoverDropdownProps,
  PopoverDropdown as MantinePopoverDropdown,
} from '@mantine/core';

export type PopoverProps = MantinePopoverProps;
export type PopoverTargetProps = MantinePopoverTargetProps;
export type PopoverDropdownProps = MantinePopoverDropdownProps;

export const Popover = MantinePopover;
Popover.displayName = 'Popover';

export const PopoverTarget = MantinePopoverTarget;
PopoverTarget.displayName = 'PopoverTarget';

export const PopoverDropdown = MantinePopoverDropdown;
PopoverDropdown.displayName = 'PopoverDropdown';
